/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";

const InputWithAddOns = ({ options = [], name, onChange, value, placeholder, onKeyDown, onKeyUp }) => {

    const [inputValue, setInputValue] = useState('');
    const [selectValue, setSelectValue] = useState(value);

    const handleSelectChange = (event) => {
        const { value } = event.target;
        setSelectValue(value);

        dispatch({ select: value });
    }

    const handleTextChange = (event) => {
        const { value } = event.target;
        setInputValue(value);

        dispatch({ input: value });
    }

    const dispatch = ({ select = selectValue, input = inputValue }) => {
        const v = { target: { name, value: { select, input } } };

        if (onChange) {
            onChange(v);
        }
    }

    return (
        <div className="field has-addons">
            <p className="control">
                <span className="select">
                    <select onChange={handleSelectChange} value={selectValue}>
                        {options.map((o) => (
                            <option key={o.value} value={o.value}>{o.label}</option>
                        ))};
                    </select>
                </span>
            </p>

            <p className="control is-expanded">
                <input className="input" type="text"
                    onKeyUp={onKeyUp} onKeyDown={onKeyDown}
                    onChange={handleTextChange} placeholder={placeholder} />
            </p>
        </div>
    );
};

export { InputWithAddOns };
